import request from "./request.js";
import { getConfig } from "@/utils/index.js";

export function getAllinfo() {
  return request({
    url: "/bp-sso/bp-sso-api/ext/app/https/appconfig/query?appId=1",
    method: "get",
  });
}

export function login(data) {
  return request({
    url: "/ext/user/for/bplanding/email/auto/register/user/and/login",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

// 获取验证码
export function getCaptcha(data) {
  return request({
    url: "/ext/user/captcha/for/bplanding/by/email/register/apply",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

// 提交日志
export function saveLog(data) {
  return request({
    url: "/ext/user/operate/log/save",
    method: "post",
    data,
    baseURL: getConfig("mainbiz"),
  });
}

// 提交接口
export function baiduExecute(params) {
  return request({
    url: "/ext/user/baidu/api/history/baidu/api/execute",
    method: "get",
    params,
    baseURL: getConfig("sso"),
  });
}
